import {
  SingleSizeIllustrationFeedbackActiveHappy,
  SingleSizeIllustrationFeedbackActiveNeutral,
  SingleSizeIllustrationFeedbackActiveSad,
  SingleSizeIllustrationFeedbackActiveVeryHappy,
  SingleSizeIllustrationFeedbackActiveVerySad,
  SingleSizeIllustrationFeedbackDefaultHappy,
  SingleSizeIllustrationFeedbackDefaultNeutral,
  SingleSizeIllustrationFeedbackDefaultSad,
  SingleSizeIllustrationFeedbackDefaultVeryHappy,
  SingleSizeIllustrationFeedbackDefaultVerySad,
} from '@xing-com/illustrations';

import type { IllustrationMap } from './feedback-button.types';

export const illustrations: IllustrationMap = {
  primary: {
    happy: {
      default: SingleSizeIllustrationFeedbackActiveHappy,
      hover: SingleSizeIllustrationFeedbackActiveHappy,
      focus: SingleSizeIllustrationFeedbackActiveHappy,
      active: SingleSizeIllustrationFeedbackActiveHappy,
      disabled: SingleSizeIllustrationFeedbackActiveHappy,
    },
    neutral: {
      default: SingleSizeIllustrationFeedbackActiveNeutral,
      hover: SingleSizeIllustrationFeedbackActiveNeutral,
      focus: SingleSizeIllustrationFeedbackActiveNeutral,
      active: SingleSizeIllustrationFeedbackActiveNeutral,
      disabled: SingleSizeIllustrationFeedbackActiveNeutral,
    },
    sad: {
      default: SingleSizeIllustrationFeedbackActiveSad,
      hover: SingleSizeIllustrationFeedbackActiveSad,
      focus: SingleSizeIllustrationFeedbackActiveSad,
      active: SingleSizeIllustrationFeedbackActiveSad,
      disabled: SingleSizeIllustrationFeedbackActiveSad,
    },
    'very-happy': {
      default: SingleSizeIllustrationFeedbackActiveVeryHappy,
      hover: SingleSizeIllustrationFeedbackActiveVeryHappy,
      focus: SingleSizeIllustrationFeedbackActiveVeryHappy,
      active: SingleSizeIllustrationFeedbackActiveVeryHappy,
      disabled: SingleSizeIllustrationFeedbackActiveVeryHappy,
    },
    'very-sad': {
      default: SingleSizeIllustrationFeedbackActiveVerySad,
      hover: SingleSizeIllustrationFeedbackActiveVerySad,
      focus: SingleSizeIllustrationFeedbackActiveVerySad,
      active: SingleSizeIllustrationFeedbackActiveVerySad,
      disabled: SingleSizeIllustrationFeedbackActiveVerySad,
    },
  },
  secondary: {
    happy: {
      default: SingleSizeIllustrationFeedbackDefaultHappy,
      hover: SingleSizeIllustrationFeedbackActiveHappy,
      focus: SingleSizeIllustrationFeedbackActiveHappy,
      active: SingleSizeIllustrationFeedbackActiveHappy,
      disabled: SingleSizeIllustrationFeedbackDefaultHappy,
    },
    neutral: {
      default: SingleSizeIllustrationFeedbackDefaultNeutral,
      hover: SingleSizeIllustrationFeedbackActiveNeutral,
      focus: SingleSizeIllustrationFeedbackActiveNeutral,
      active: SingleSizeIllustrationFeedbackActiveNeutral,
      disabled: SingleSizeIllustrationFeedbackDefaultNeutral,
    },
    sad: {
      default: SingleSizeIllustrationFeedbackDefaultSad,
      hover: SingleSizeIllustrationFeedbackActiveSad,
      focus: SingleSizeIllustrationFeedbackActiveSad,
      active: SingleSizeIllustrationFeedbackActiveSad,
      disabled: SingleSizeIllustrationFeedbackDefaultSad,
    },
    'very-happy': {
      default: SingleSizeIllustrationFeedbackDefaultVeryHappy,
      hover: SingleSizeIllustrationFeedbackActiveVeryHappy,
      focus: SingleSizeIllustrationFeedbackActiveVeryHappy,
      active: SingleSizeIllustrationFeedbackActiveVeryHappy,
      disabled: SingleSizeIllustrationFeedbackDefaultVeryHappy,
    },
    'very-sad': {
      default: SingleSizeIllustrationFeedbackDefaultVerySad,
      hover: SingleSizeIllustrationFeedbackActiveVerySad,
      focus: SingleSizeIllustrationFeedbackActiveVerySad,
      active: SingleSizeIllustrationFeedbackActiveVerySad,
      disabled: SingleSizeIllustrationFeedbackDefaultVerySad,
    },
  },
};
